import json from './theme-colors.json'

export default json
